import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {connect} from 'react-redux';
import reduxRouteChanged from 'services/reduxRouteChanged.js';
import AuthLayout from 'components/layout/auth/AuthLayout';
import {injectIntl} from 'react-intl';
import styles from './email-registration.scss';
import {replace} from "react-router-redux";
import registerurl from "../../../utils/url/registerUrl";

@injectIntl
@connect(
  () => {},
  dispatch => ({
    redirect: (path) => dispatch(replace(path)),
  })
)

@CSSModules(styles)
class EmailRegistration extends React.Component {
  static propTypes = {
    redirect: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.redirect(registerurl());
  }

  render() {
    return (
      <AuthLayout>
      </AuthLayout>
    );
  }
}

function initStore() {}

export default reduxRouteChanged(initStore, EmailRegistration);



// WEBPACK FOOTER //
// ./src/containers/auth/email-registration/EmailRegistration.js